// components/Surveys/ScaleInput.js
import React from 'react'
import styled from 'styled-components'
import RcSlider from 'rc-slider'
import 'rc-slider/assets/index.css'

const Container = styled.div`
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
`
const NumericContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 16px;
`

const NumberButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 4px;
  font: 14px/1 'Inter', sans-serif;
  cursor: pointer;
  transition: opacity 0.15s;
  background: ${({ hue, selected }) =>
    selected
      ? `hsl(${hue},100%,50%)`
      : `hsl(${hue},100%,75%)`};
  color: ${({ selected }) => (selected ? '#fff' : '#000')};

  &:hover:not(:disabled) {
    opacity: 0.85;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

const SliderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 16px;
`

const ValueDisplay = styled.div`
  width: 40px;
  text-align: center;
  font: 14px/1 'Inter', sans-serif;
  color: #111827;
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  padding: 4px 0;
`

export default function ScaleInput({ question, value = 0, onChange }) {
  const min = question.scaleMin || 0
  const max = question.scaleMax || 10
  const fmt = question.scaleFormat || 'numeric'

  if (fmt === 'numeric') {
    return (
      <Container>
        <NumericContainer>
          {Array.from({ length: max - min + 1 }, (_, i) => {
            const v = min + i
            const selected = v === value
            const ratio = (v - min) / ((max - min) || 1)
            const hue = Math.round(ratio * 120) 
            return (
              <NumberButton
                key={v}
                hue={hue}
                selected={selected}
                onClick={() => onChange(v)}
              >
                {v}
              </NumberButton>
            )
          })}
        </NumericContainer>
      </Container>
    )
  }
  return (
    <Container>
      <SliderContainer>
        <RcSlider
          min={min}
          max={max}
          value={value}
          onChange={onChange}
          trackStyle={[{ backgroundColor: '#28AAE1', height: 8 }]}
          railStyle={{ backgroundColor: '#E5E7EB', height: 8 }}
          handleStyle={[
            {
              borderColor: '#28AAE1',
              backgroundColor: '#28AAE1',
              height: 16,
              width: 16,
              marginTop: -4,
            },
          ]}
          dotStyle={{ display: 'none' }}
        />
        <ValueDisplay>{value}</ValueDisplay>
      </SliderContainer>
    </Container>
  )
}
